












































import { Component, Vue } from "vue-property-decorator";
import UnitApi from "@/accounting/api/unit-api";
import { client } from "../../../api/request";
import Unit from "@/accounting/entities/unit";
import VToolbar from "../../common/components/VToolbar.vue";
import VDraggableList from "../../../components/VDraggableList.vue";
import VDraggableListItem from "../../../components/VDraggableListItem.vue";

const unitRepository = new UnitApi(client);

@Component({
  components: {
    VToolbar,
    VDraggableList,
    VDraggableListItem
  }
})
export default class UnitPage extends Vue {
  unit = new Unit();
  units: Unit[] = [];

  newUnit() {
    this.showModal(new Unit());
  }

  edit(unit: Unit) {
    this.showModal(unit);
  }

  async save() {
    await unitRepository.save(this.unit);
    await this.loadUnitList();
    this.hideModal();
  }

  async destroy(unit: Unit) {
    await unitRepository.destroy(unit);
    await this.loadUnitList();
    this.hideModal();
  }

  async sort(units: Unit[]) {
    this.units = units;
    await unitRepository.sort(units);
    await this.loadUnitList();
  }

  protected created() {
    this.loadUnitList();
  }

  private async loadUnitList() {
    this.units = await unitRepository.findAll();
  }

  private showModal(unit: Unit) {
    this.unit = unit;
    this.$nextTick(() => {
      (this.$refs.modal as any).show();
    });
  }

  private hideModal() {
    this.$nextTick(() => {
      (this.$refs.modal as any).hide();
    });
  }
}
